// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder_placeholder__81Msi","lg":"Placeholder_lg__XqSAR","md":"Placeholder_md__GBMHO","sm":"Placeholder_sm__v6C_c","xs":"Placeholder_xs__L6MBk"};